export default __webpack_public_path__ + "static/media/home-bg3.ddc8e8ef.svg";